<template>
  <div class="UserHeader">
    <div class="Toolbar">
      <div class="Toolbar-Left" @click="_onClickGoBack">
        <font-awesome-icon :icon="['fal', 'angle-left']" size="2x" />
        <span class="u-ml10 TextWithIcon">得意先一覧</span>
      </div>
    </div>
    <el-row>
      <el-col :span="4">
        <div class="UserHeaderTopRight">
          {{ clientGroup.name }}
        </div>
      </el-col>
      <el-col
        v-if="!hideCreateUserButton"
        :offset="16"
        :span="4"
      >
        <div class="UserHeaderTopLeft">
          <el-button type="primary" @click="_onClickCreateNew"
            >ユーザーを作成</el-button
          >
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {},
  props: {
    hideCreateUserButton: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {};
  },
  computed: {
    ...mapState({
      clientGroup: state => state.user.clientsGroup,
    }),
  },
  methods: {
    _onClickGoBack () {
      this.$router.push("/admin/clients");
    },
    _onClickCreateNew () {
      const { $router } = this;
      $router.push("users/create");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

::v-deep .el-tabs__nav-wrap::after {
  background-color: transparent;
}

.UserHeader {
  width: 95%;
  margin: 5px auto 0 1rem;
}
.UserHeaderTopRight {
  width: 500px;
  font-weight: bold;
  margin-top: 0.5rem;
  margin-right: 2rem;
  margin-left: 1rem;
}
.UserHeaderTopLeft {
  margin-bottom: 1rem;
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: center;
}
@media (min-width: 767px) {
  .UserHeaderTopLeft {
    margin-left: 5rem !important;
  }
}
@media (max-width: 768px) {
  .UserHeaderTopLeft {
    margin-right: 1.1rem;
    margin-left: 0 !important;
  }
}
</style>
